// @flow

import React from 'react'; /* eslint-disable-line no-unused-vars */

import { Colors, IconButton } from '@zapier/design-system';
import { isolateComponent, labelStyles } from '@zapier/common-utils';

/** @jsx isolateComponent */

type Props = {
  onClose: () => void,
};

const Styles = labelStyles(__filename, {
  root: {
    position: 'absolute',
    right: 0,
    top: 0,
  },
});

const TrialCloseButton = (props: Props) => {
  return (
    <div css={Styles.root}>
      <IconButton
        color="transparent"
        colorTheme={{
          transparent: {
            base: {
              backgroundColor: Colors.transparent,
              color: Colors.white,
            },
            disabled: {
              backgroundColor: Colors.grey100,
              color: Colors.grey500,
            },
            hover: {
              backgroundColor: `${Colors.grey900}44`,
              color: Colors.white,
            },
            focus: {
              backgroundColor: Colors.transparent,
              outlineColor: Colors.blue500,
              color: Colors.white,
            },
          },
        }}
        icon="formX"
        label="Close"
        onClick={props.onClose}
        tooltipPosition="west"
      />
    </div>
  );
};

export default TrialCloseButton;
